import { Button as ButtonV2 } from "../Button";
import type { MarketingBannersTranslations } from "./types";

type RenameBannerFooterProps = {
  isSaving: boolean;
  isSaveDisabled: boolean;
  translations: MarketingBannersTranslations;
  onCancel: () => void;
  onSave: () => void;
};

export const RenameBannerFooter = ({
  isSaving,
  isSaveDisabled,
  translations,
  onCancel,
  onSave,
}: RenameBannerFooterProps) => {
  return (
    <div className="flex w-full flex-row gap-3 lg:justify-end lg:gap-4">
      <ButtonV2
        variant="outline"
        className="flex-1 lg:flex-none"
        onClick={onCancel}
        disabled={isSaving}
      >
        {translations.rename.cancel}
      </ButtonV2>
      <ButtonV2
        variant="brand"
        className="flex-1 lg:flex-none"
        onClick={onSave}
        disabled={isSaveDisabled}
        isLoading={isSaving}
      >
        {translations.rename.save}
      </ButtonV2>
    </div>
  );
};
